import React from 'react'
import QRCode from 'qrcode.react'

import './pix.scss'

const Pix = ({qrcode}) => {

    return <div className={'pix'}>
        <QRCode className={'qrcode'} value={qrcode}/>
    </div>
}

export default Pix
